import { COLOR_NEUTRALS_3, COLOR_NEUTRALS_6_LIGHT } from '../colors.constant';

export const colorsNftDetailsModalsLight = {
  colorsNftDetailsModalsTitle: COLOR_NEUTRALS_3,
};

export const colorsNftDetailsModalsDark = {
  colorsNftDetailsModalsTitle: COLOR_NEUTRALS_6_LIGHT,
};
